module.exports = __webpack_public_path__ + "img/cancel.612036dd.svg";